import { useContext } from 'react';
import { PatientResourcesContext } from './PatientResourcesContext';

// Hook to access patient resources from the PatientResourcesContext.
// Must be used within a PatientResourcesProvider.

export const usePatientResources = () => {
  const context = useContext(PatientResourcesContext);

  if (!context) {
    throw new Error(
      'usePatientResources must be used within a PatientResourcesProvider'
    );
  }

  return context;
};
